import React from "react";
import { useTranslation } from "react-i18next";
import "../../styles/components/ScrollToTopButton.css";

export default function ScrollToTopButton({
  isVisible,
  onClick,
  label,
}) {
  const { t } = useTranslation();

  if (!isVisible) {
    return null;
  }

  const accessibleLabel = label || t("scroll_to_top");

  return (
    <button
      type="button"
      className="scroll-to-top-button"
      onClick={onClick}
      aria-label={accessibleLabel}
      title={accessibleLabel}
    >
      <span className="scroll-to-top-button__icon" aria-hidden="true">
        {"\u2191"}
      </span>
    </button>
  );
}
